// extracted by mini-css-extract-plugin
export default {"notice":"PCRSNotOnPanelNotice_notice__TwDDW","icon":"PCRSNotOnPanelNotice_icon__+RpbF","text":"PCRSNotOnPanelNotice_text__cwza+"};